<template>

      <vs-popup
        class="holamundo"
        title="Enrolled Students"
        :active.sync="showStudentListModal"
      >
      <div
        style="max-height: 250px; overflow: auto"
        class="vertical_scrollbar horizontal_scrollbar"
        @scroll="detectsScrollLength()"
        ref="element"
        >

        <vs-table :data="students" class="cstm_vuexy_table">
          <template slot="thead">
            <vs-th style="width: 80px">Image</vs-th>
            <vs-th>Name</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].picture">
                <img
                  class="imgpic"
                  :src="data[indextr].picture ? data[indextr].picture : 'http://scoolio-dev.track-progress.com/img/user-circle-solid.c3580913.svg'"
                  style="height: 40px; width: 40px; object-fit: contain"
                />
              </vs-td>
              <vs-td>
                {{ data[indextr].first_name }}
                {{ data[indextr].last_name }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      </vs-popup>
    <!-- </div> -->

</template>

<script>
import { studentsFetchByStaff } from '@/api/teacher'
export default {
  props:{
    showStudentListModal:{
      default:false
    },
    user_id:{
      default:null
    }
  },
  name: 'StudentsListAction',
  data () {
    return {
      students: [],

      meta:{
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  watch: {
    showStudentListModal () {
      if (!this.showStudentListModal) {
        this.$emit('StudentPopupClose', false)
      }
    }
  },
  mounted () {
    this.fetchStudents()
  },
  methods: {
    async detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight  &&  this.meta.has_next
      ) {
        this.meta.current_page =  this.meta.current_page + 1
        this.loadMore()
      }
    },
    async loadMore () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}
        payload.limit = 10
        payload.user_id = this.user_id
        const {data} = await studentsFetchByStaff(
          localStorage.getItem('customer_id'),
          this.user_id,
          this.meta.current_page,
          payload
        )

        this.courseLists.push(...data.data.students)
        this.meta = data.data.meta
      } catch (error) {
        //
        this.$vs.loading.close()

        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    async fetchStudents () {
      try {
        const payload = {
          limit:10
        }
        const { data } = await studentsFetchByStaff(
          localStorage.getItem('customer_id'),
          this.user_id,
          this.meta.current_page,
          payload
        )
        this.students = data.data.students
        this.meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
